import { TextType } from '@user-portal/wikr-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGetCFLink } from 'hooks/common/useGetCFLink';

import * as S from './styled';

const ContactUsLink = ({
    onClick,
    dataLocator,
    text,
    type,
    boldText,
    withUnderline,
    leftAligned,
}: {
    onClick?: () => void;
    dataLocator?: string;
    text?: string;
    type?: TextType;
    boldText?: boolean;
    withUnderline?: boolean;
    leftAligned?: boolean;
}) => {
    const { t } = useTranslation();
    const link = useGetCFLink();

    return (
        <a href={link} target="_blank" rel="noreferrer" onClick={onClick} data-locator={dataLocator}>
            <S.LinkText
                type={type ?? 'overline'}
                $withUnderline={withUnderline}
                $center={!leftAligned}
                $bold={boldText}
            >
                {text ?? t('basics.contactUs')}
            </S.LinkText>
        </a>
    );
};

export default ContactUsLink;
